<div #controlesZoom class="jornal-zoom-flutuante" role="group" aria-label="Controle de zoom do conteúdo do jornal">
  <button type="button" class="jornal-zoom-flutuante__botao" data-test-id="btn-aumentar-zoom"
    [disabled]="!podeAumentarZoom"
    (click)="aumentarZoom()" [attr.aria-label]="'Aumentar zoom do jornal. Zoom atual: ' + percentualZoom + '%'">
    <span class="jornal-zoom-flutuante__texto">Aumentar zoom</span>
    <span class="jornal-zoom-flutuante__icone jornal-zoom-flutuante__icone--mais" aria-hidden="true"></span>
  </button>
  <button type="button" class="jornal-zoom-flutuante__botao" data-test-id="btn-diminuir-zoom"
    [disabled]="!podeDiminuirZoom"
    (click)="diminuirZoom()" [attr.aria-label]="'Diminuir zoom do jornal. Zoom atual: ' + percentualZoom + '%'">
    <span class="jornal-zoom-flutuante__texto">Diminuir zoom</span>
    <span class="jornal-zoom-flutuante__icone jornal-zoom-flutuante__icone--menos" aria-hidden="true"></span>
  </button>
</div>

@if (materias.length > 0) {
  <div class="jornal-topo-flutuante">
    <button type="button" class="jornal-html__topo" data-test-id="btn-voltar-ao-topo"
      (click)="voltarAoTopo()" aria-label="Voltar ao topo da edição">
      Voltar<br>ao topo
    </button>
  </div>
}

<section class="jornal-html" [class.jornal-html--zoom]="nivelZoom !== 1" [style.zoom]="nivelZoom" aria-live="polite">
  <div class="download-edicao-container">
    <button class="download-edicao-completa-button" data-test-id="btn-baixar-edicao-completa"
      (click)="baixarCadernoEdicaoCompleto()">
      <span class="icone-download-edicao" role="img" aria-label="ícone de download"></span>
      Baixar edição completa
    </button>
  </div>
  <header class="jornal-html__cabecalho">
    <img class="jornal-html__marca" src="images/brasao-mg-edicao-html.svg"
      alt="Brasão do Estado de Minas Gerais, Minas Gerais, Diário Oficial eletrônico">
    <p class="jornal-html__edicao">
      Belo Horizonte, {{ formatarData(edicao.dataPublicacao) }} | Ano {{ edicao.anoEdicao }} - Nº {{ edicao.numeroEdicao }}
    </p>
    <h2>{{ caderno.nome }}</h2>
  </header>

  @for (materia of materias; track materia.publicacaoId) {
    <article class="materia-html">
      @if (caderno.tipoCaderno === diarioExecutivo) {
        @for (nivel of materia.cadeiaHierarquica; track $index) {
          <div class="materia-html__orgao" [class.materia-html__orgao--principal]="$first">
            <h3>{{ nivel.nomeOrgao }}</h3>
            @if (nivel.responsavelLegal) {
              <p>{{ nivel.responsavelLegal }}</p>
            }
          </div>
        }
        <h4 class="materia-html__secao">{{ materia.secao }}</h4>
        @if (materia.subunidade) {
          <h4 class="materia-html__subunidade">{{ materia.subunidade }}</h4>
        }
      } @else if (caderno.tipoCaderno === diarioMunicipios) {
        @if (materia.nomeMunicipio) {
          <h3 class="materia-html__municipio">{{ materia.nomeMunicipio }}</h3>
        }
        <h4 class="materia-html__secao">{{ materia.secao }}</h4>
      } @else if (caderno.tipoCaderno === diarioTerceiros) {
        <h3 class="materia-html__municipio">{{ materia.secao }}</h3>
      }

      <div class="download-publicacao-container">
        <button class="download-publicacao-button" [attr.data-test-id]="'btn-baixar-publicacao-' + materia.publicacaoId"
          [disabled]="publicacaoIdEmDownload !== null"
          (click)="baixarPublicacao(materia.publicacaoId)">
          <span class="icone-download-publicacao" role="img" aria-label="ícone de download"></span>
          Baixar publicação
        </button>
      </div>
      <p class="materia-html__numero">Número da publicação: {{ materia.numeroMateria }}</p>
      <div class="materia-html__conteudo" [innerHTML]="materia.conteudo"></div>
    </article>
  }

  @if (carregando) {
    <div class="jornal-html__estado" role="status">Carregando matérias...</div>
  } @else if (erro) {
    <div class="jornal-html__estado" role="alert">{{ erro }}</div>
  } @else if (!materias.length) {
    <div class="jornal-html__estado">Nenhuma publicação encontrada para o filtro selecionado.</div>
  }

  @if (possuiProximaPagina && !carregando) {
    <div class="jornal-html__acoes">
      <button type="button" class="jornal-html__carregar" data-test-id="btn-carregar-mais"
        (click)="carregarMais.emit()">Carregar mais</button>
    </div>
  }
</section>
